import { Injectable } from '@angular/core';

import { TextDocumentTemplate } from '../../models/text-document-template';

import { BackendBaseService } from '../backend-base.service';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class TextDocumentTemplateService extends BackendBaseService {
  /**
   * URL for client intakes controller
   * @type {String}
   */
  url = 'text_document_templates';

  /**
   * Constructor
   * @param {HttpClientService} private httpClient Service for making HTTP requests with different methods
   */
  constructor(public httpClient: HttpClientService) {
    super(httpClient);
  }

  /**
   * CREATE and UPDATE actions for Text Document Template resource
   * @param  {TextDocumentTemplate} phone_number Text Document Template to be saved
   * @return {Promise<any>} Save response
   */
  save(textDocumentTemplate: TextDocumentTemplate): Promise<any> {
    return super.save({
      text_document_template: textDocumentTemplate,
      id: textDocumentTemplate.id
    });
  }

  /**
   * SHOW action for Text Document Template resource
   * @param  {number}       id Text Document Template id
   * @return {Promise<any>}    Response of edit
   */
  show(id: number, matter_id: number | null = null): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}.json`, { matter_id: matter_id });
  }
}
